export default {
      id: "icon-tv-ve-uydu-yayini-usage",
      viewBox: "0 0 507.4 507.4",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-tv-ve-uydu-yayini",
      toString: function () {
        return this.url;
      }
    }